import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation AddBasketItem($input: AddBasketItemInput!) {
    addBasketItem(input: $input) {
      addBasketItem {
        basket {
          id
          count
          monthlyPrice
          term
          totalMonthlyGrossAmount
          disposalFee
          endOfAgreementFee
          totalSavings
          totalRrp
          headroomValue
          basketItems {
            id
            productId
            brochureGroupId
            name
            link
            quantity
            imageUrl
            price
            totalAmount
            term
            brand
            category
            variant
            sku
            storeName
            department
            supplierName
            status
            releaseDate
          }
        }
        errors
      }
    }
  }
`

export const getAddBasketItemMutationKey = getQueryNames(mutation)[0]
export default mutation
